export const transaction_summary_display = {
  outstanding_badge: "Outstanding",
  fully_allocated: "Fully allocated",
  amount_label: "Amount",
  allocated_label: "Allocated",
  remaining_label: "Remaining",
  counterparty_label: "Counterparty",
  description_label: "Description",
  status_label: "Status",
  posted_at_label: "Posted",
  empty_cell: "—",
};
